/*
 * @Autor: Nehc
 * @Date: 2020-12-18 16:42:46
 * @LastEditors: Nehc
 * @LastEditTime: 2020-12-18 16:46:39
 */
import LogView from './log_view.vue';

export default LogView;
